module.exports = __webpack_public_path__ + "img/macs-big-transparent.c60b9ed1.png";